import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import GrooverText from '../GrooverText'
import { formatGrooverText, getGrooverText } from '../../libs/GrooverTextRepository'
import { usePortalAuth } from '../../hooks/usePortalAuth'
import { usePortalDisplayName } from '../../hooks/usePortalDisplayName'
import useAppState from '../../hooks/useAppState'

const Banner = styled.div`
  position: sticky;
  top: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 16px;
  background: #111827;
  color: #ffffff;
  font-size: 14px;
`

const ExitButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 600;
`

const formatRemaining = (expiresAt: string, nowMs: number): string => {
  const remainingMs = Math.max(0, Date.parse(expiresAt) - nowMs)
  const totalSeconds = Math.ceil(remainingMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export const PortalViewAsBanner: React.FC = () => {
  const { isViewAs, viewAsExpiresAt, portalUser, exitViewAs } = usePortalAuth()
  const { displayName } = usePortalDisplayName(portalUser?.enrollmentUserId ?? null)
  const { state } = useAppState()
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    if (!isViewAs || !viewAsExpiresAt) {
      return
    }
    const intervalId = window.setInterval(() => setNowMs(Date.now()), 1000)
    return () => window.clearInterval(intervalId)
  }, [isViewAs, viewAsExpiresAt])

  if (!isViewAs) {
    return null
  }

  const label = displayName
    ? formatGrooverText(getGrooverText('portalViewAsBannerNamed', state.selectedLanguage), [displayName])
    : getGrooverText('portalViewAsBanner', state.selectedLanguage)

  return (
    <Banner role="status">
      <span>
        {label}
        {viewAsExpiresAt
          ? ` · ${formatGrooverText(getGrooverText('portalViewAsExpiresIn', state.selectedLanguage), [
              formatRemaining(viewAsExpiresAt, nowMs)
            ])}`
          : null}
      </span>
      <ExitButton type="button" onClick={() => void exitViewAs()}>
        <GrooverText textKey="portalViewAsExit" />
      </ExitButton>
    </Banner>
  )
}
